// (function() {
//   console.log("triggered")
//   const _addEventListener = EventTarget.prototype.addEventListener;

//   EventTarget.prototype.addEventListener = function(type, listener, options) {
//     const wrappedListener = function(event) {
//       if (event.type.includes('cart')) {
//         // console.log(`[Event Fired] type: ${event.type}, target:`, event.target);
//         console.log(event);
//         console.log("=================")
//       }
//       return listener.call(this, event);
//     };

//     return _addEventListener.call(this, type, wrappedListener, options);
//   };
// })();


document.addEventListener('teeinblue-event-after-cart-added', function(event) {
  BT.updateHeaderCartHtml()
  setTimeout(() => {
    if(window.innerWidth < 1000) {
      // document.querySelector('.header__cart-trigger-mobile').click();
      document.querySelector('.bt-sidebar-btn[data-target="#bt-sidebar-cart"]').click()
    } else {
      document.querySelector('.header__cart-trigger-desktop').click();
    }
  }, 1000)
});